import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || "https://qmnlihdhycoavgxkmykm.supabase.co"
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFtbmxpaGRoeWNvYXZneGtteWttIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ0MzI2OTIsImV4cCI6MjA5MDAwODY5Mn0.mjoG3AC_3e_v8sajYM684eKNhJ9BhaAfnnMl3wj3w8o"

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY)
